import client from 'api/client';

interface SingleProgramParams {
    country: string;
    program_name: string;
    candidate_id: string;
    enhanced_with_job_offers?: boolean;
    enhanced_language?: boolean;
    language?: string;
}

export function getSingleProgram({
    country,
    program_name,
    candidate_id,
    enhanced_with_job_offers = false,
    enhanced_language = false,
    language = 'EN',
}: SingleProgramParams) {
    const params = new URLSearchParams();
    if (country) params.append('country', country);
    if (program_name) params.append('program_name', program_name);
    if (candidate_id) params.append('candidate_id', candidate_id);
    params.append('enhanced_with_job_offers', String(enhanced_with_job_offers));
    params.append('enhanced_language', String(enhanced_language));
    if (language) params.append('language', language);

    return client.get(`assessment/single-program?${params.toString()}`);
}
